import { Component, uiEvent } from "@kluntje/core";
import { addClass } from "@kluntje/js-utils/lib/dom-helpers";
import { IN_VP_EVENT, ViewportObserver } from "@kluntje/services";
import ConsentManagementService from "Services/ConsentManagementService";

export class WECGoogleMap extends Component {
  private viewportObserver = ViewportObserver.getInstance();

  get defaultIframeUrl() {
    return "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2305.2781193280243!2d8.51125611654919!3d54.70472988028614!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b4efa512d5d119%3A0xf75b2903d16268b7!2sBraren%20Werbetechnik!5e0!3m2!1sde!2sde!4v1625125926552!5m2!1sde!2sde";
  }

  get iframeUrl() {
    return this.getAttribute("iframe-url") || this.defaultIframeUrl;
  }

  get hasConsent() {
    return ConsentManagementService.getConsent("google-maps");
  }

  afterComponentRender() {
    if (this.hasConsent) {
      this.viewportObserver.observe(this);
    } else {
      this.remove();
    }
  }

  @uiEvent("this", IN_VP_EVENT)
  handleInVp() {
    this.viewportObserver.unobserve(this);
    this.renderIframe();
  }

  renderIframe() {
    const iframe = document.createElement("iframe");
    addClass(iframe, "wec-m-google-map__iframe");
    iframe.setAttribute("src", this.iframeUrl);
    this.appendChild(iframe);
  }
}

customElements.define("wec-m-google-map", WECGoogleMap);
